<template>
  <van-radio-group v-model="checked">
    <van-cell-group inset>
      <van-cell
        :title="item.name"
        :key="item.id"
        clickable
        v-for="item in list"
        @click="checkedEvt(item.id, item)"
      >
        <template #right-icon>
          <van-radio :name="item.name" :checked="checked === item.id">
            <template #icon="props">
              <van-image
                class="img-icon"
                width="18px"
                height="18px"
                :src="
                  props.checked
                    ? require('@/assets/image/common/checked.png')
                    : require('@/assets/image/common/un_checked.png')
                "
              />
            </template>
          </van-radio>
        </template>
      </van-cell>
    </van-cell-group>
  </van-radio-group>
</template>

<script>
import { ref, toRefs } from "vue"
export default {
  name: "FilterRadio",
  props: {
    defaultId: {
      type: [Number, String],
      default: 10000,
    },
    list: {
      type: Array,
      default() {
        return [
          {
            id: 1,
            name: "临时会议",
          },
          {
            id: 2,
            name: "预约拜访",
          },
        ]
      },
    },
  },
  setup(props, { emit }) {
    let { defaultId } = toRefs(props)
    const checked = ref(defaultId.value)
    const checkedEvt = (id, item) => {
      checked.value = id
      emit("onChange", item)
    }
    return {
      checked,
      checkedEvt,
    }
  },
}
</script>

<style lang="less" scoped></style>
